import moment from 'moment';
import {useNavigate} from 'react-router-dom';

import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";

import AppointmentSummary from '../scheduling/AppointmentSummary';
import './SignupComplete.scss';
import FormLayout from "./FormLayout";
import TitleDivider from "./TitleDivider";


const SignupComplete = props => {
  const navigate = useNavigate();
  const {selectedProvider, patientId, sessionType, onSubmit, time, date} = props;

  return (
    <FormLayout
      className='signup-complete'
      padding='9px 27px 36px 27px'
      marginTop={{xs: '16px', sm: '0'}}
    >
      <TitleDivider text='Booking Request Summary' style={{marginBottom: '2em'}}/>
      <Stack marginTop={1} marginBottom={1}>
        <AppointmentSummary
          provider={selectedProvider}
          sessionType={sessionType}
          date={moment(date)}
          time={time}
          className="signup-complete__appointment-summary"
          scheduleManually={props?.scheduleManually}
          booked={true}
        />
      </Stack>
      <Typography variant='large500Tight' marginTop='11.25px'>
        Please check your email for any final coordination with your provider.
      </Typography>

      <Button
        variant='primaryGradient'
        size='medium'
        onClick={() => onSubmit()}
        className="signup-complete__done-button"
      >
        Done
      </Button>

      <TitleDivider text='Optional Next Steps' style={{marginTop: '2em'}}/>
      <Stack gap={1} alignItems='center'>
        <Typography variant='large500Tight' textAlign='left'>
          You’re all set, but if you’d like to submit additional medical and/or insurance information, please click below.
        </Typography>

        <Button
          variant='primaryOutline'
          size='medium'
          disabled={!patientId}
          onClick={() => navigate(`/clients/view/${patientId}?excludeAccountInfo=true`)}
        >
          <Typography variant='small' lineHeight='1.25rem' textAlign='left' letterSpacing='0px'>
            Submit Medical info
          </Typography>
        </Button>

        <Button
          size='medium'
          variant='primaryOutline'
          href='https://docs.google.com/forms/d/e/1FAIpQLSeZjxUEbtww31jOLit9rxFMTMJoCxsokv1pbvUIHW9_nNkEcg/viewform'
          target='_blank'
        >
          <Typography variant='small' lineHeight='1.25rem' textAlign='left' letterSpacing='0px'>
            Verify My Benefits
          </Typography>
        </Button>
      </Stack>
    </FormLayout>
  );
};

export default SignupComplete;
